export default "__VITE_ASSET__heMUFpvc__"